export default __webpack_public_path__ + "static/media/community8.6b0f9c27.svg";